// extracted by mini-css-extract-plugin
module.exports =  {"root":"NF21HHo_OiS4RCupZgsP","deleteIcon":"BvTDqdo4mzCbmLrysFw4"};